import { render, staticRenderFns } from "./DialogConfirmPassword.pug?vue&type=template&id=8b9eff28&lang=pug&"
import script from "./DialogConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports